import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  Notification,
  NotificationService,
  NotificationType,
} from '../../../core/services/notification/notification.service';

/**
 * T11 (security-backlog 2026-04-22) — Toast container for the
 * canonical NotificationService. Subscribes to `notifications$`
 * and renders a stack at top-right with auto-dismiss + manual close.
 */
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
    imports: [CommonModule],
  selector: 'app-notification-toast-container',
  templateUrl: './notification-toast-container.component.html',
  styleUrls: ['./notification-toast-container.component.scss'],
})
export class NotificationToastContainerComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  // Expose enum to the template so the type comparison is safe.
  readonly Type = NotificationType;

  private sub?: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.sub = this.notificationService.notifications$.subscribe((list) => {
      this.notifications = list;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  dismiss(id: string): void {
    this.notificationService.dismiss(id);
  }

  invokeAction(notif: Notification): void {
    notif.action?.callback();
    this.notificationService.dismiss(notif.id);
  }

  trackById(_idx: number, notif: Notification): string {
    return notif.id;
  }
}
